import { Component, OnInit } from '@angular/core';
import {Title } from "@angular/platform-browser";
declare var $: any;

@Component({
  selector: 'app-arizona',
  templateUrl: './arizona.component.html',
  styleUrls: ['./arizona.component.css']
})
export class ArizonaComponent implements OnInit {

  public windowwidth:number;
  constructor(
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    this.windowwidth=$(window).width();
    this.topposition();
    this.titleService.setTitle("Arizona - SFI Compliance, Inc");
  }

  //scroll to top of the page automatically
  topposition() { 
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
}

}
